import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js';
import {
  CSS3DObject,
  CSS3DRenderer,
} from 'three/examples/jsm/renderers/CSS3DRenderer.js';
import {
  AmbientLight,
  DoubleSide,
  MeshBasicMaterial,
  PlaneGeometry,
  Scene,
} from 'three';
import { Mesh } from 'three';

@Component({
    selector: 'app-frames',
    templateUrl: './frames.component.html',
    styleUrls: ['./frames.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FramesComponent implements OnInit {
  constructor() {}

  ngOnInit() {
    const options = [
      '1318661_1',
      '1318661_1_',
      '1318661_2',
      '1318661_2_',
      '1318661_3',
      '1318661_3_',
      '1318881_1',
      '1318881_1_',
      '1318881_2',
      '1318881_2_',
      '1318881_3',
      '1318881_3_',
      '1521661_1',
      '1521661_1_',
      '1521661_2',
      '1521661_2_',
      '1521661_3',
      '1521661_3_',
      '1521881_1',
      '1521881_1_',
      '1521881_2',
      '1521881_2_',
      '1521881_3',
      '1521881_3_',
      '1523661_1',
      '1523661_1_',
      '1523661_2',
      '1523661_2_',
      '1523661_3',
      '1523661_3_',
      '1523881_1',
      '1523881_1_',
      '1523881_2',
      '1523881_2_',
      '1523881_3',
      '1523881_3_',
      '2030661_3_',
      '2030661_3',
      '2030881_3',
      '2030881_3_',
      '1015661_1',
      '1015661_1_',
      '1015661_2',
      '1015661_2_',
      '1015661_3',
      '1015661_3_',
      '1015881_1',
      '1015881_1_',
      '1015881_2',
      '1015881_2_',
      '1015881_3',
      '1015881_3_',
    ];
    Promise.all(
      options.map(async (option) => {
        const loader = new GLTFLoader();
        const split = option.split('_');
        const modelPath = `/assets/lookbook/frames/gltf/${option.substr(
          0,
          6
        )}_${split[1]}${split.length === 3 ? '_' : ''}.gltf`;
        console.log('LOADING MODEL', modelPath, ' for option ', option);

        const model = await loader.loadAsync(modelPath);

        const canvas = document.createElement('canvas');

        // const renderer2 = new WebGLRenderer({
        //   antialias: true,
        //   canvas,
        //   alpha: true,
        // });
        // renderer2.setSize(1920, 1080);
        // renderer2.setClearColor(0x000000, 0);

        const renderer = new CSS3DRenderer();
        renderer.setSize(1920, 1080);

        const container = document.createElement('div');
        container.id = `${option.substr(0, 6)}_${split[1]}${
          split.length === 3 ? '_' : ''
        }`;
        container.appendChild(canvas);

        const overlay = document.createElement('img');
        overlay.src = `https://zalamo.com/gfx/frames/${option}.png`;

        overlay.classList.add('overlay');
        container.appendChild(overlay);
        document.getElementById('container').appendChild(container);
        container.appendChild(renderer.domElement);
        const canvasBounds = canvas.getBoundingClientRect();
        const scene = new Scene();
        const clone = model.scene.clone();
        scene.add(clone);
        const light = new AmbientLight(0x404040); // soft white light
        scene.add(light);
        const camera = scene.children[0].children[1].clone() as any;
        const element = document.createElement('div');
        element.className = 'element';
        element.style.backgroundColor = 'rgba(0,127,127,.7)';
        element.style.position = 'relative';
        const img = new Image();
        if (split.length === 3) {
          img.src = `https://images.unsplash.com/photo-1673943508686-8c07973110d4?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1470&q=80`;
        } else {
          img.src = `https://images.unsplash.com/photo-1673943004813-45c59233d067?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=687&q=80`;
        }

        element.appendChild(img);
        img.style.objectFit = 'cover';
        img.style.width = 'calc(100% + 6px)';
        img.style.height = 'calc(100% + 6px)';
        img.style.position = 'absolute';
        img.style.top = '-3px';
        img.style.left = '-3px';
        const objectCSS = new CSS3DObject(element);
        const mesh = (await new Promise((resolve) => {
          scene.traverse((ob) => {
            if (ob.name.startsWith('foto')) {
              resolve(ob as Mesh);
            }
          });
          resolve(null);
        })) as Mesh;
        objectCSS.position.copy(mesh.position);
        objectCSS.scale.copy(mesh.scale);
        // scene.background = await new TextureLoader().loadAsync(overlay.src);
        scene.children[0].children[0].add(objectCSS);
        const size = {
          x:
            Math.abs(mesh.geometry.boundingBox.min.x) +
            Math.abs(mesh.geometry.boundingBox.max.x),
          y:
            Math.abs(mesh.geometry.boundingBox.min.y) +
            Math.abs(mesh.geometry.boundingBox.max.y),
          z:
            Math.abs(mesh.geometry.boundingBox.min.z) +
            Math.abs(mesh.geometry.boundingBox.max.z),
        };
        const sorted = Object.values(size).sort((a, b) => b - a);

        if (split.length === 3) {
          // objectCSS.position.setY(objectCSS.position.y + sorted[1] / 2);
        }
        objectCSS.element.style.width = `${
          (split.length === 3 ? sorted[0] : sorted[1]) * 100
        }px`;
        element.style.height = `${
          (split.length === 3 ? sorted[1] : sorted[0]) * 100
        }px`;

        objectCSS.rotation.copy(mesh.rotation);
        objectCSS.scale.set(0.01, 0.01, 0.01);
        const geometry = new PlaneGeometry(
          split.length === 3 ? sorted[0] : sorted[1],
          split.length === 3 ? sorted[1] : sorted[0]
        );
        const material = new MeshBasicMaterial({
          color: 0xffa500,
          side: DoubleSide,
        });
        mesh.visible = false;
        const plane = new Mesh(geometry, material);
        plane.position.copy(mesh.position);
        plane.rotation.copy(mesh.rotation);
        scene.children[0].children[0].add(plane);
        plane.quaternion.copy(mesh.quaternion);
        // scene.children[0].children[2].visible = false;
        console.log(scene);
        renderer.render(scene, camera);
        // renderer2.render(scene, camera);
      })
    ).then(() => {
      console.log('ALL DONE');
      console.log(
        Object.fromEntries(
          Array.from(document.querySelectorAll('#container > div > div')).map(
            (el) => [el.parentElement.id, el.outerHTML]
          )
        )
      );
    });
  }
}
